import * as React from 'react';

const PencilFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="pencil-fill_svg__eds-icon--pencil-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="pencil-fill_svg__eds-icon--pencil-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7 4.8L3.6 16 8 20.4 19.2 9.3l-4.5-4.5z"
        />
        <path
            id="pencil-fill_svg__eds-icon--pencil-fill_eraser"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5 2l-2.1 2.1 4.5 4.5L22 6.5z"
        />
        <path
            id="pencil-fill_svg__eds-icon--pencil-fill_tip"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 22l5.1-1.1-4-4z"
        />
        <g
            id="pencil-fill_svg__eds-icon--pencil-fill_dashes"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M12 21h2v1h-2zM16 21h2v1h-2zM20 21h2v1h-2z" />
        </g>
    </svg>
);

PencilFillSvg.displayName = 'PencilFillSvg';
export default PencilFillSvg;
